import {
  type PageEntity,
  apiClient,
  type PartnerListExEntity
} from '@/libs/api'
import { type PartnersListRequestQuery } from '@/libs/api/types'

export type FetchPartnersListQuery = {
  tenantKey: string
  query?: PartnersListRequestQuery
}

export type FetchPartnersListResponse = {
  data: PartnerListExEntity[]
  pagination: PageEntity | null
}

export const fetchPartnersList = async (
  { tenantKey, query }: FetchPartnersListQuery,
  signal?: AbortSignal
): Promise<FetchPartnersListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .partners.list.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
